import { create } from 'zustand'
import { acionsTypesSupervisionMenuCount, Action, Dispatch } from '../../logic/actionsType'
import { ISupervisionMenuCount, INotification } from '../../../interfaces'

type TReqesutState = {
  menuCountInfo?: ISupervisionMenuCount | undefined
  allNotifications?: INotification[] | undefined
  currentPage?: number
  search?: string
  pageSizeC?: number
  totalRecords?: number
  showAddModal?: boolean
  selectId?: number
  notificationListIsFetching?: boolean
  showDeleteModal?: boolean
  showActiveModal?: boolean
}

type State = {
  state: TReqesutState
}

const reducer = (
  state: State,
  action: Action<keyof typeof acionsTypesSupervisionMenuCount, TReqesutState>
): State => {
  switch (action.type) {
    case 'SET_MENUCOUNT_DATA':
      return { state: { ...state.state, menuCountInfo: action.payload.menuCountInfo } }
    case 'SET_NOTIFICATION_DATA':
      return { state: { ...state.state, allNotifications: action.payload.allNotifications } }
    case 'CURRENTTPAGE_NOTIFICATION_LIST':
      return { state: { ...state.state, currentPage: action.payload.currentPage } }
    case 'PAGESIZE_NOTIFICATION_LIST':
      return { state: { ...state.state, pageSizeC: action.payload.pageSizeC } }
    case 'SEARCH_NOTIFICATION_LIST':
      return { state: { ...state.state, search: action.payload.search } }
    case 'SET_NOTIFICATION_ID':
      return { state: { ...state.state, selectId: action.payload.selectId } }
    case 'SET_SHOW_ADD_NOTIFICATION':
      return { state: { ...state.state, showAddModal: action.payload.showAddModal } }
    case 'TOTALRECORD_NOTIFICATION_LIST':
      return { state: { ...state.state, totalRecords: action.payload.totalRecords } }
    case 'SET_FETCHING_NOTIFICATION':
      return { state: { ...state.state, notificationListIsFetching: action.payload.notificationListIsFetching } }
    case 'SET_SHOW_DELETE_NOTIFICATION':
      return { state: { ...state.state, showDeleteModal: action.payload.showDeleteModal } }
    case 'SET_SHOW_ACTIVE_NOTIFICATION':
      return { state: { ...state.state, showActiveModal: action.payload.showActiveModal } }
    default:
      return state
  }
}

export const useSupervisionMenuCountStore = create<
  State & Dispatch<keyof typeof acionsTypesSupervisionMenuCount, TReqesutState>
>((set) => ({
  state: {
    menuCountInfo: undefined,
    allNotifications: [],
    currentPage: 0,
    pageSizeC: 20,
    search: '',
    totalRecords: 0,
    showAddModal: false,
    notificationListIsFetching: false,
    showDeleteModal: false,
    showActiveModal: false,
  },
  dispatch: (action) => {
    set((state: State) => reducer(state, action))
  },
}))
